import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={20}
    height={29}
    viewBox={'0 0 20 29'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <Path
      stroke={props.fill || '#000'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.97}
      d="M7.342 27.86c-.79-3.11-.69-3.5-2.53-5.96-1.36-1.82-2.34-3.85-3.58-6.02-.48-.83-.19-1.89.63-2.37.83-.48 1.89-.19 2.37.63.56.97 1.12 1.94 1.68 2.92.4.6 1.44.11 1.42-.5V5.99c0-.76.62-1.38 1.38-1.38.76 0 1.38.62 1.38 1.38v6.42c0-.76.62-1.38 1.38-1.38.76 0 1.38.62 1.38 1.38v.64c0-.76.62-1.38 1.38-1.38.76 0 1.38.62 1.38 1.38v1.29c0-.76.62-1.38 1.38-1.38.76 0 1.38.62 1.38 1.38.27 3.28.54 5.97-.64 8.31-.77 1.91-.96 3.1-1.52 5.21m-4.82-20.13a3.235 3.235 0 0 0-2.71-4.99c-1.78 0-3.23 1.45-3.23 3.23 0 .68.21 1.31.57 1.83m6.09 1.78c.95-.91 1.55-2.19 1.55-3.6 0-2.76-2.23-4.98-4.98-4.98-2.75 0-4.97 2.22-4.97 4.97 0 1.77.92 3.32 2.31 4.2"
    />
  </Svg>
);
export default SvgComponent;
